
import store from '../../config/store'

export default {
  components: {
    'component-dropzone': () => import(/* webpackChunkName: "components" */ '../dropzone'),
    'component-button': () => import(/* webpackChunkName: "components" */ '../Button.vue'),
    CloseIcon: () => import(/* webpackChunkName: "svg" */ `../../../${process.env.VUE_APP_DOMAIN}/assets/svg/ic-close.svg`)
  },

  data: () => ({
    store
  }),

  computed: {
    url () {
      return store.modal.dataModel.url || (store.api.base + '/operations/' + store.modal.dataModel.id + '/documents')
    },

    paramName () {
      return store.modal.dataModel.paramName || 'files'
    },

    hasMultipleFiles () {
      if (store.modal.dataModel.hasOwnProperty('multipleFiles')) {
        return !!store.modal.dataModel.multipleFiles
      } else {
        return true
      }
    },

    isLocal () {
      return !!store.modal.dataModel.isLocal
    }
  },

  mounted () {
    this.$bus.$on('upload-success', this.onUploadSuccess)
    this.$bus.$on('local-file-added', this.onCloseModal)
  },

  destroyed () {
    this.$bus.$off('upload-success', this.onUploadSuccess)
    this.$bus.$off('local-file-added', this.onCloseModal)
  },

  methods: {
    onCloseModal () {
      store.modal.active = false
    },

    onAddFiles () {
      if (this.isLocal) {
        this.$bus.$emit('add-local-file')
        this.onCloseModal()
      } else {
        this.$bus.$emit('upload-file')
      }
    },

    onUploadSuccess (response) {
      if (store.modal.dataModel.hasOwnProperty('documents')) {
        store.modal.dataModel.documents = response.documents
      } else if (store.modal.dataModel.hasOwnProperty('document')) {
        store.data.user.picture = response
        this.$bus.$emit('on-profile-picture-added')
      }
      this.$bus.$emit('on-files-loaded', response)
      this.onCloseModal()
    }
  }
}
